import React, { useEffect } from 'react';
import { useProjectConfiguration } from '../../services/customer-account';
import { useNavigator } from '../../framework/services/navigation';
import { getNextShoppingUrl } from '../app-routes';

const subscriberId = 'HomePage';

export const HomePage: React.FunctionComponent = () => {
  const projectConfig = useProjectConfiguration(subscriberId);
  const nav = useNavigator();

  useEffect(() => {
    nav.goTo(getNextShoppingUrl(projectConfig));
  }, [projectConfig, nav]);

  return (
    <></>
  );
};
